module.exports = __webpack_public_path__ + "media/images/emblems/Pollegio-coat_of_arms-595c3ddae4c6b52e7a8df718e776a3b7.svg";